<script>
  import { onMount } from 'svelte'
  import DataTable from '../DataTable/DataTable.svelte'
  import { Button } from 'smelte'
  import Select from 'smelte/src/components/Select'
  import Snackbar from 'smelte/src/components/Snackbar'
  import { conditionMonitoringAPI } from './api.js'
  import { parameter } from './store'
  import { pop } from 'svelte-spa-router'

  export let params = {}

  const api = new conditionMonitoringAPI()
  let data = {
    platform: null,
    name: '',
    type: null,
    instruction: '',
    limits: [
      {name: 'New (nominal)', value: 0},
      {name: 'Half worn-out', value: 0},
      {name: 'To be changed', value: 0},
    ],
  }
  const fmt1 = '[0-9]([,\.][0-9]+)?'
  let saving = false
  let chainsMap = {}
  let chains = []
  $: setChains(data.platform)

  $: isNew = params.id === 'new'

  const LOWER_BOUND = 'lower_bound'
  const UPPER_BOUND = 'upper_bound'

  const funcItems = [
    {value: LOWER_BOUND, text: 'Lower bound'},
    {value: UPPER_BOUND, text: 'Upper bound'},
  ]

  let instructions = [
    // 'CM_Gap_Chain_Beam_Instruction.png',
    // 'CM_Length_Instruction.png',
    // 'CM_Thickness_Chain_Instruction.png',
    // 'CM_Thickness_Tab_Instruction.png'
  ]

  let platformItems = [
    {value: 'X180', text: 'X180'},
    {value: 'X300', text: 'X300'},
    {value: 'X45', text: 'X45'},
    {value: 'X65', text: 'X65'},
    {value: 'X85', text: 'X85'},
    {value: 'XH', text: 'XH'},
    {value: 'XK', text: 'XK'},
    {value: 'XL', text: 'XL'},
    {value: 'XS', text: 'XS'},
    {value: 'XT', text: 'XT'},
    {value: 'WL', text: 'WL'},
    {value: 'WLX', text: 'WLX'},
    {value: 'X70X', text: 'X70X'},
    {value: 'X45H', text: 'X45H'},
    {value: 'X45C', text: 'X45C'},
    {value: 'X85X', text: 'X85X'},
    {value: 'X180X', text: 'X180X'},
    {value: 'X300X', text: 'X300X'},
  ]

  let snackbar = {
    show: false,
    message: '',
    color: ''
  }

  function setChains(platform) {
    if (chainsMap == null || platform == null) {
      chains = []
      return
    }
    const tmp = chainsMap[platform]
    if (tmp == null) {
      chains = []
      return
    }
    chains = tmp
  }

  function snack (color, message) {
    snackbar.message = message
    snackbar.color = color
    snackbar.show = true
  }

  onMount(async () => {
    await api.getChains()
      .then(res => {
        if (res.data != null) {
          chainsMap = res.data
        }
      })
    api.getInstructions()
      .then(res => {
        if (res.data != null && Array.isArray(res.data)) {
          instructions = res.data.map(p => {
            const parts = p.split('/')
            const filename = parts[parts.length - 1]
            return filename
          })
        }
      })
    api.getProductProps()
      .then(res => {
        if (res != null && res.data != null) {
          platformItems = res.data.groups.map(g => { return {value: g, text: g} })
        }
      })
      .catch(err => {
        console.log('[ERROR] getProductProps', err)
      })


    if (isNew) {
    }

    if (!isNew) {
      if ($parameter._id == null || $parameter._id !== params.id) {
        console.log('[DEBUG] fetch parameter, id:', params.id)
        await api.getOneParam(params.id)
          .then(res => {
            decodeLimits(res.data)
            $parameter = res.data
            console.log('[DEBUG] parameter', res.data)
          })
          .catch(err => {
            console.log('[ERROR]', err)
          })
      }
      data = $parameter
    }


  })

  function decodeLimits (data) {
    data.limits.forEach(p => {
      p.value = p.value / 1000
    })
  }

  function encodeLimits (data) {
    data.limits.forEach(p => {
      p.value = p.value * 1000
    })
  }

  function fallback (value) {
    return value == null ? '-' : value
  }

  function verifyLimitFunction(data) {
    data.func = data.limits[0].value > data.limits[data.limits.length - 1].value
      ? LOWER_BOUND : UPPER_BOUND
  }

  function saveHandler () {
    saving = true
    setTimeout(() => {
      saving = false
    }, 1000)

    verifyLimitFunction(data)

    // api save
    let payload = JSON.parse(JSON.stringify(data))
    encodeLimits(payload)
    if (isNew) {
      api.createMeasurementParameter(payload)
        .then(res => {
          snack('success', 'Saved successfully.')
          params.id = res.data
          data._id = res.data
        })
        .catch(err => {
          snack('error', 'Something went wrong.')
          console.log('[ERROR]', err)
        })
      return
    }
    api.updateMeasurementParameter(payload)
      .then(res => {
        snack('success', 'Saved successfully.')
      })
      .catch(err => {
        snack('error', 'Something went wrong.')
        console.log('[ERROR]', err)
      })
  }

</script>

<div class="container mx-auto px-8 bg-white text-left pt-1 pb-5 text-gray-700 text-lg">
  <div class="flex header bg-white my-12 lg:w-1/2 mx-auto">
    <div class="text-xl text-black">MEASUREMENT PARAMETER</div>
  </div>

  <div class="lg:w-1/2 mx-auto">
    <div class="row flex h-12 border-b border-gray-400 items-center">
      <div class="w-1/3 text-base label">Machine model / Product group</div>
      <div class="w-2/3 h-full pb-5 bg-gray-200">
        <Select placeholder="select ..."
                listClasses="h-64 overflow-x-auto"
                noUnderline dense
                items={platformItems}
                bind:value={data.platform}
                remove="pt-4" add="pt-2 text-gray-700 bg-gray-200"
        />
      </div>
    </div>
    <div class="row flex h-12 border-b border-gray-400 items-center">
      <div class="w-1/3 text-base label">Chain</div>
      <div class="w-2/3 h-full pb-5 bg-gray-200">
        <Select placeholder="select conveyor platform"
                listClasses="overflow-x-auto overflow-y-auto"
                noUnderline dense
                items={chains}
                bind:value={data.chain}
                remove="pt-4" add="pt-2 text-gray-700 bg-gray-200"
        />
      </div>
    </div>
    <div class="row flex h-12 border-b border-gray-400 items-center">
      <div class="w-1/3 text-base label">Name</div>
      <div class="w-2/3 h-full">
        <input class="px-3 bg-gray-200 h-full w-full text-left focus:bg-gray-300 edit"
               type=text placeholder="parameter name"
               bind:value={data.name}
        />
      </div>
    </div>
    <div class="row flex h-12 border-b border-gray-400 items-center">
      <div class="w-1/3 text-base label">Type</div>
      <div class="w-2/3 h-full pb-5 bg-gray-200">
        <Select placeholder="select limits type"
                noUnderline dense
                items={funcItems}
                bind:value={data.func}
                remove="pt-4" add="pt-2 text-gray-700 bg-gray-200"
        />
      </div>
    </div>
    <div class="row flex h-12 border-b border-gray-400 items-center">
      <div class="w-1/3 text-base label">Instruction</div>
      <div class="w-2/3 h-full pb-5 bg-gray-200">
        <Select placeholder="select limits type"
                noUnderline dense
                items={instructions}
                bind:value={data.instruction}
                remove="pt-4" add="pt-2 text-gray-700 bg-gray-200"
        />
      </div>
    </div>
  </div>

  <div class="lg:w-1/2 pt-12 mx-auto">
    {#if data.limits}
      {#each data.limits as limit, i}
        <div class="row flex h-12 border-b border-gray-400 items-center">
          <div class="w-1/3 text-base label">Limit {i + 1}</div>
          <div class="w-1/3 h-full">
            <input class="px-3 bg-gray-200 h-full w-full text-left focus:bg-gray-300 edit"
                   type=text placeholder="name"
                   bind:value={limit.name}
            />
          </div>
          <div class="w-1/3 h-full border-l border-gray-400">
            <input class="px-3 bg-gray-200 h-full w-full text-left focus:bg-gray-300 edit"
                   pattern={fmt1} step="0.1" max="9999"
                   type=number placeholder="0.0" min=0
                   bind:value={limit.value}
            />
          </div>
        </div>
      {/each}
    {/if}
  </div>

  <div class="mt-8 mb-5 w-full text-center">
    <Button text color="red" bind:disabled={saving} on:click={saveHandler}>SAVE</Button>
    <Button text color="red" on:click={() => { pop() }}>GO Back</Button>
  </div>
</div>

<Snackbar bind:value={snackbar.show}
          bind:color={snackbar.color}
          timeout={2000}>
  <div>{snackbar.message}</div>
</Snackbar>

<style>
    .edit {
    }

    .edit:focus {
        color: black;
    }
</style>
